import CTip from "./tip";
export default CTip;
